import { useToast, Box, Spacer, Stack, InputGroup, Input, Badge,
         InputLeftElement, Button, TableContainer, Table, Td, Thead,
         Tbody, Tr, Th, Tooltip, Menu, MenuButton, MenuList, MenuItem,
         IconButton, Portal, Drawer, DrawerOverlay, DrawerContent,
         DrawerHeader, DrawerBody } from '@chakra-ui/react';
import { SmallAddIcon, SearchIcon, WarningIcon, CheckIcon,
         HamburgerIcon, EditIcon, DownloadIcon } from '@chakra-ui/icons';
import ComponentHeader from './ComponentHeader';
import GruntComponents from '../components';
import { loggedOper as lp, colorSchmemes } from '../../util/grunt';
import { useState, useEffect, useMemo } from "react";
import { getKnjige, addKnjiga, updateKnjiga } from "../../util/apiKnjiga";
import { exportData_MigracijeKnjige } from '../../util/apiUtil';
import KnjigaControl from '../knjiga/KnjigaControl';
import KategorijaVrijednost from '../knjiga/KategorijaVrijednost';

const Knjige = ({ onClosePress }) => {
    const [state, setState] = useState({
        showknjiga: 0,
        knjige: [],
        errormsg: "",
        newknjiga: false,
        successmsg: "",
        reloadtoggle: false,
        filter: "",
        showdobrobit: 0,   // ID knjige za Dobrobit drawer
        exportKnjigaId:0,
    });
    const [loading, setLoading] = useState(false);
    const userCanEdit = lp.uloga === "a";
    const toast = useToast();

    // ── Dohvat podataka ───────────────────────────────────────────────────────
    useEffect(() => {
        const fetchKnjige = async () => {
            try {
                const res = await getKnjige();
                if (res.status === 200) {
                    setState(s => ({ ...s, knjige: res.res }));
                } else {
                    throw new Error(res.message);
                }
            } catch (error) {
                setState(s => ({ ...s, errormsg: error.message }));
            }
        };
        fetchKnjige();
    }, [state.reloadtoggle]);

    // ── Filtriranje ───────────────────────────────────────────────────────────
    const filteredKnjige = useMemo(() => {
        const q = state.filter.toLowerCase().trim();
        if (!q) return state.knjige;
        return state.knjige.filter(k =>
            k.naziv?.toLowerCase().includes(q) ||
            k.jibg?.toLowerCase().includes(q) ||
            k.ikg?.toLowerCase().includes(q) ||
            k.posjednik_naziv?.toLowerCase().includes(q) ||
            k.vlasnik_naziv?.toLowerCase().includes(q) ||
            k.lokacija?.toLowerCase().includes(q)
        );
    }, [state.knjige, state.filter]);

    // ── Poruke ────────────────────────────────────────────────────────────────
    const errorMessage = () => {
        if (state.errormsg !== "") {
            setState({ ...state, errormsg: "" });
            toast({
                title: "Greška kod dohvata podataka.",
                status: "error",
                description: state.errormsg,
                isClosable: true,
                duration: 2000,
                position: "top-right",
            });
        }
    };

    const successMessage = () => {
        if (state.successmsg !== "") {
            setState({ ...state, successmsg: "" });
            toast({
                title: state.successmsg,
                status: "success",
                isClosable: true,
                duration: 2000,
                position: "top-right",
            });
        }
    };

    // ── Gumb Dodaj ────────────────────────────────────────────────────────────
    const btnNew = () => {
        if (!userCanEdit) return <></>;
        return (
            <Button
                mb={'0.5rem'}
                rightIcon={<SmallAddIcon />}
                colorScheme={'grunt2'}
                variant={'outline'}
                size={'xs'}
                onClick={() => setState({ ...state, newknjiga: true })}
            >
                Dodaj
            </Button>
        );
    };

    // ── KnjigaControl drawer ──────────────────────────────────────────────────
    const KnjigaContr = () => {
        if (state.showknjiga !== 0) {
            return (
                <KnjigaControl
                    knjigaid={state.showknjiga}
                    readonly={!userCanEdit}
                    onCloseControl={() => setState({ ...state, showknjiga: 0 })}
                    onSave={(knjiga) => SaveKnjiga(knjiga)}
                />
            );
        }
        if (state.newknjiga) {
            return (
                <KnjigaControl
                    knjigaid={0}
                    readonly={false}
                    onCloseControl={() => setState({ ...state, newknjiga: false })}
                    onSave={(knjiga) => SaveKnjiga(knjiga)}
                />
            );
        }
    };

    // ── Dobrobit drawer ───────────────────────────────────────────────────────
    const DobrobitDrawer = () => {
        if (state.showdobrobit === 0) return null;
        const knjiga = state.knjige.find(k => k.id === state.showdobrobit);
        return (
            <Drawer
                placement='right'
                size={'lg'}
                isOpen={true}
                onClose={() => setState({ ...state, showdobrobit: 0 })}
            >
                <DrawerOverlay />
                <DrawerContent roundedTopLeft={'md'}>
                    <DrawerHeader
                        pt='5px'
                        roundedTopLeft={'md'}
                        h={'40px'}
                        color={'white'}
                        bg={'grunt2.700'}
                        //fontSize={'sm'}
                    >
                        POVRŠINA PO KATEGORIJI — {knjiga?.naziv}
                    </DrawerHeader>
                    <DrawerBody>
                        {/* Ovdje će doći KategorijaVrijednost komponenta */}
                        <KategorijaVrijednost
                            knjigaId={state.showdobrobit}
                            namjenaKey="dobrobit"
                            onClose={() => setState({ ...state, showdobrobit: 0 })}
                            onSave={() => setState({ ...state,reloadtoggle:!state.reloadtoggle,showdobrobit: 0, successmsg: "Vrijednosti uspješno snimljene." })}
                        />
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        );
    };

    // ── Spremi/ažuriraj knjigu ────────────────────────────────────────────────
    const SaveKnjiga = async (knjiga) => {
        if (!state.newknjiga && state.showknjiga === 0) return;
        try {
            let res;
            if (state.newknjiga) {
                res = await addKnjiga(knjiga);
            } else {
                res = await updateKnjiga(knjiga);
            }
            if (res.status === 200) {
                setState({
                    ...state,
                    newknjiga: false,
                    showknjiga: 0,
                    reloadtoggle: !state.reloadtoggle,
                    successmsg: "Podatak uspješno unesen.",
                });
            } else {
                throw new Error(res.message);
            }
        } catch (err_add) {
            setState({ ...state, errormsg: err_add.message });
        }
    };
    //---------------------------Funkcija za eksport podataka--------------------
    const  handleExportData=async(knjigaId)=> {
        setLoading(true);
        try {
        await exportData_MigracijeKnjige(knjigaId);
        toast({ title: 'Eksport dovršen', status: 'success' });
        } catch (err) {
        toast({ title: 'Greška pri eksportu', description: err.message, status: 'error' });
        } finally {
        setLoading(false);
        }
  }
    // ── Pomoćne funkcije za površinu ──────────────────────────────────────────
    const isPrekoraceno = (item) =>
        parseFloat(item.zauzeta_povrsina) > parseFloat(item.povrsina);

    const postotak = (item) => {
        const p = parseFloat(item.povrsina);
        const z = parseFloat(item.zauzeta_povrsina);
        if (!p) return 0;
        return Math.min(Math.round((z / p) * 100), 100);
    };

    // ── Stil zajedničkih th ───────────────────────────────────────────────────
    const thStyle = {
        fontSize: 'xs',
        textAlign: 'center',
        zIndex: '5',
        pos: 'sticky',
        top: '0',
        color: 'grunt2.800',
        bg: 'white',
        borderTopWidth: '1px',
        borderTopColor: 'black',
        borderBottomWidth: '1px',
        borderBottomColor: 'black',
        textTransform: 'none'
    };

    // ── Render ────────────────────────────────────────────────────────────────
    return (
        <Box h={'100%'} borderColor={'silver'} borderBottomRightRadius={'md'}
             borderWidth={'0.5px'} key='knjige_component' pl='1rem' pr={'0.5rem'}>

            <ComponentHeader onClosePress={onClosePress} component={GruntComponents.Knjige} />

            {/* Toolbar */}
            <Box display={'flex'} alignItems={'center'} mb={'0.25rem'}>
                <InputGroup size={'xs'} w='20rem'>
                    <InputLeftElement pointerEvents={'none'} children={<SearchIcon />} />
                    <Input
                        focusBorderColor='grunt2.400'
                        placeholder='Filter (naziv, JIBG, IKG, posjednik, lokacija...)'
                        maxLength={'50'}
                        value={state.filter}
                        onChange={(e) => setState({ ...state, filter: e.target.value })}
                    />
                </InputGroup>
                <Spacer />
                <Stack direction={'row'} spacing={'1rem'} mr={'1rem'}>
                    {btnNew()}
                </Stack>
            </Box>

            {errorMessage()}
            {successMessage()}
            {KnjigaContr()}
            {DobrobitDrawer()}

            {/* Tablica */}
            <Box>
                <TableContainer overflowY={'auto'} h={'78vh'}>
                    <Table variant={'unstyled'} size='xs'
                           style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
                        <Thead>
                            <Tr>
                                {/* Rbr */}
                                <Th {...thStyle} textAlign={'right'} w={'2rem'}>#</Th>
                                {/* Akcija */}
                                <Th {...thStyle} w={'2rem'}></Th>

                                <Th {...thStyle}>NAZIV</Th>
                                <Th {...thStyle}>JIBG</Th>
                                <Th {...thStyle}>IKG</Th>
                                <Th {...thStyle}>POSJEDNIK</Th>
                                <Th {...thStyle}>VLASNIK</Th>

                                {/* Površina — razdvojeno */}
                                <Th {...thStyle} textAlign={'right'}>POVRŠINA (m²)</Th>
                                <Th {...thStyle} textAlign={'right'}>ZAUZETO (m²)</Th>
                                <Th {...thStyle} textAlign={'center'} w={'7rem'}>POPUNJENOST</Th>

                                <Th {...thStyle}>LOKACIJA</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {filteredKnjige.map((item, i) => {
                                const prekoraceno = isPrekoraceno(item);
                                const pct = postotak(item);

                                return (
                                    <Tr
                                        key={item.id}
                                        bg={'white'}
                                        fontWeight={'normal'}
                                        _hover={{ bg: 'gray.100' }}
                                        h='2rem'
                                    >
                                        {/* Rbr */}
                                        <Td fontSize={'xs'} textAlign={'right'}
                                            color={'gray.400'} pr={'0.75rem'}>
                                            {i + 1}
                                        </Td>

                                        {/* Hamburger menu */}
                                        <Td textAlign={'center'} p={'2px'}>
                                            <Menu strategy='fixed'>
                                                <MenuButton
                                                    as={IconButton}
                                                    aria-label='Opcije'
                                                    icon={<HamburgerIcon />}
                                                    variant={'outline'}
                                                    //colorScheme={'grunt2'}
                                                    size={'xs'}
                                                />
                                                <Portal>
                                                    <MenuList zIndex={1400}>
                                                        <MenuItem
                                                            fontSize={'xs'}
                                                            icon={<EditIcon boxSize={'12px'} />}
                                                            onClick={() => setState({ ...state, showknjiga: item.id })}
                                                        >
                                                            Pregled / Izmjena
                                                        </MenuItem>
                                                        <MenuItem
                                                            fontSize={'xs'}
                                                            icon={<EditIcon boxSize={'12px'} />}
                                                            onClick={() => setState({ ...state, showdobrobit: item.id })}
                                                        >
                                                            Podna površina (parametri)
                                                        </MenuItem>
                                                        <MenuItem
                                                            fontSize={'xs'}
                                                            icon={<DownloadIcon boxSize={'12px'} />}
                                                            onClick={() => handleExportData(item.id)} isDisabled={loading}
                                                        >
                                                            Preuzmi podatke goveda
                                                        </MenuItem>
                                                    </MenuList>
                                                </Portal>
                                            </Menu>
                                        </Td>

                                        <Td fontSize={'xs'} textAlign={'center'}>{item.naziv}</Td>
                                        <Td fontSize={'xs'} textAlign={'center'}>{item.jibg}</Td>
                                        <Td fontSize={'xs'} textAlign={'center'}>{item.ikg}</Td>
                                        <Td fontSize={'xs'} textAlign={'center'}>
                                            {item.posjednik_naziv} ({item.posjednik_sifra})
                                        </Td>
                                        <Td fontSize={'xs'} textAlign={'center'}>
                                            {item.vlasnik_naziv} ({item.vlasnik_sifra})
                                        </Td>

                                        {/* Površina farme */}
                                        <Td fontSize={'xs'} textAlign={'right'} pr={'1rem'}>
                                            {Number(item.povrsina).toFixed(2)}
                                        </Td>

                                        {/* Zauzeta površina */}
                                        <Td fontSize={'xs'} textAlign={'right'} pr={'1rem'}
                                            color={prekoraceno ? 'red.600' : 'green.600'}
                                            fontWeight={prekoraceno ? '600' : 'normal'}>
                                            <Tooltip
                                                label={prekoraceno
                                                    ? `Prekoračenje za ${(parseFloat(item.zauzeta_povrsina) - parseFloat(item.povrsina)).toFixed(2)} m²`
                                                    : `Slobodno ${(parseFloat(item.povrsina) - parseFloat(item.zauzeta_povrsina)).toFixed(2)} m²`}
                                                placement='left'
                                                fontSize={'xs'}
                                            >
                                                <Box as='span' display={'inline-flex'} alignItems={'center'} gap={'0.25rem'}>
                                                    {prekoraceno
                                                        ? <WarningIcon color='red.500' boxSize={'10px'} />
                                                        : <CheckIcon color='green.500' boxSize={'10px'} />
                                                    }
                                                    {Number(item.zauzeta_povrsina).toFixed(2)}
                                                </Box>
                                            </Tooltip>
                                        </Td>

                                        {/* Progress bar popunjenosti */}
                                        <Td textAlign={'center'} pl={'1.5rem'} pr={'1rem'}>
                                            <Tooltip
                                                label={`${pct}% popunjeno`}
                                                fontSize={'xs'}
                                                placement='left'
                                            >
                                                <Box w={'100%'} bg={'gray.100'} borderRadius={'full'} h={'6px'} overflow={'hidden'}>
                                                    <Box
                                                        h={'6px'}
                                                        borderRadius={'full'}
                                                        w={`${pct}%`}
                                                        bg={prekoraceno ? 'red.400' : pct > 80 ? 'orange.400' : 'green.400'}
                                                        transition={'width 0.3s'}
                                                    />
                                                </Box>
                                            </Tooltip>
                                        </Td>

                                        {/* Lokacija */}
                                        <Td fontSize={'xs'} textAlign={'center'}>
                                            <Badge
                                                variant={'solid'}
                                                colorScheme={colorSchmemes[(item.lokacija.length + item.lokacija.charCodeAt(0)) % 16]}
                                            >
                                                {item.lokacija}
                                            </Badge>
                                        </Td>
                                    </Tr>
                                );
                            })}
                        </Tbody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
};

export default Knjige;